export interface IMasterDataRawRetailerAssociation {
  rawRetailerId: number;
  rawRetailerName: string;
  retailerId: number;
  retailerName: string | null;
}

export class MasterDataRawRetailerAssociation {
  private readonly _rawRetailerId: number;
  private readonly _rawRetailerName: string;
  private readonly _retailerId: number;
  private readonly _retailerName: string | null;

  constructor(props: IMasterDataRawRetailerAssociation) {
    this._rawRetailerId = props.rawRetailerId;
    this._rawRetailerName = props.rawRetailerName;
    this._retailerId = props.retailerId;
    this._retailerName = props.retailerName;
  }

  get rawRetailerId(): number {
    return this._rawRetailerId;
  }
  get rawRetailerName(): string {
    return this._rawRetailerName;
  }
  get retailerId(): number {
    return this._retailerId;
  }
  get retailerName(): string | null {
    return this._retailerName;
  }

  static from(
    props: IMasterDataRawRetailerAssociation,
  ): MasterDataRawRetailerAssociation {
    return new MasterDataRawRetailerAssociation(props);
  }

  static toJSON(
    entity: MasterDataRawRetailerAssociation,
  ): IMasterDataRawRetailerAssociation {
    return {
      rawRetailerId: entity.rawRetailerId,
      rawRetailerName: entity.rawRetailerName,
      retailerId: entity.retailerId,
      retailerName: entity.retailerName,
    };
  }
}
